import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeMenuItemAndGoToMenu } from 'menus/actions/menuItem';
import EditCartItem from 'cart/containers/EditCartItem';
import Modal from 'base/ui_components/Modal';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

class EditCartItemModal extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func
  };

  render() {
    const { dispatch } = this.props;

    return (
      <Modal onClose={() => dispatch(closeMenuItemAndGoToMenu())}>
        <EditCartItem {...this.props} />
      </Modal>
    );
  }
}

export default withGoogleLibraryLoaded(connect()(EditCartItemModal));
